import React, { useContext, useEffect, useState } from 'react';
import { AppSettings } from '../../config/app-settings';
import { useGetUsersQuery, useLazyGetUsersQuery } from '../../redux/apis/usersManagement/users/uMUsersApiSlice';
import { toast } from 'react-toastify';
import Loader from '../pages/loader';
import ReusableTable from '../../components/other/ReuseableTable';
import EditCreateUser from '../../components/users/EditCreateUser';
import SearchAndFilterBar from '../../components/other/search/SearchAndFilterBar';
import DownloadAllDataButton from '../../components/other/DownloadAllDataButton';
import { can } from '../../helpers/auth';

const Users = React.memo(() => {
  const [search, setSearch] = useState('')
  const [filters, setFilters] = useState({})
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10
  })

  const context = useContext(AppSettings)

  const { data, isLoading, error, isFetching } = useGetUsersQuery({
    expand: ['last_updated_by'].join(','),
    page: pagination.current,
    page_size: pagination.pageSize,
    ...(search ? { search } : {}),
    ...filters
  })

  const [holder, setHolder] = useState()
  const [edit, setEdit] = useState(false)
  const [create, setCreate] = useState(false)

  let columns = [
    { title: 'ID', dataIndex: 'id', key: 'id', sorter: true },
    {
      title: 'Email',
      dataIndex: 'email',
      key: 'email',
      filter: true,
      filterType: 'text'
    },


    {
      title: 'First Name',
      dataIndex: 'first_name',
      key: 'first_name',
      filter: true,
      filterType: 'text'
    },

    {
      title: 'Last Name',
      dataIndex: 'last_name',
      key: 'last_name',
      filter: true,
      filterType: 'text'
    },

    {
      title: 'Is Staff',
      dataIndex: 'is_staff',
      key: 'is_staff',
      filter: true,
      filterType: 'select',
      filterOptions: [
        { label: 'Yes', value: 'true' },
        { label: 'No', value: 'false' }
      ],
      render: (text, record) => (
        <div className=''>

            {text ? "YES": "NO"}

        </div>
      )
    },
    {
      title: 'Is Admin',
      dataIndex: 'is_superuser',
      key: 'is_superuser',
      filter: true,
      filterType: 'select',
      filterOptions: [
        { label: 'Yes', value: 'true' },
        { label: 'No', value: 'false' }
      ],
      render: (text, record) => (
        <div className=''>

            {text ? "YES": "NO"}

        </div>
      )
    },
    {
      title: 'Status',
      dataIndex: 'is_active',
      key: 'is_active',
      filter: true,
      filterType: 'select',
      filterOptions: [
        { label: 'Active', value: 'true' },
        { label: 'Inactive', value: 'false' }
      ],
      render: (text, record) => (
        <div className=''>

            {text ? "Active": "InActive"}

        </div>
      )
    },
    

    {
      title: 'Actions',
      dataIndex: 'id',
      key: 'actions',
      render: (text, record) => (
        <div className='flex gap-2'>
          {can('change_user') && (
            <button
              className='btn btn-outline-theme'
              onClick={() => handleEdit(record)}
            >
              Edit
            </button>
          )}
        </div>
      )
    }
  ]

  const handleEdit = record => {
    setHolder(record)
    setEdit(true)
  }

  const handleTableChange = (paginationInfo) => {
    setPagination({
      current: paginationInfo.current,
      pageSize: paginationInfo.pageSize
    })
  }

  useEffect(() => {
    if (error?.data) {
      const errorMessages = Object.values(error.data).flat()
      errorMessages.forEach(message => {
        toast.error(message)
      })
    }
  }, [error])

  useEffect(() => {
    context.setAppHeaderNone(false)
    context.setAppSidebarNone(false)
    context.setAppContentClass('')
    context.setAppThemePanal(true)

    return () => {
      context.setAppHeaderNone(true)
      context.setAppSidebarNone(true)
      context.setAppContentClass('p-0')
      context.setAppThemePanal(false)
    }
  }, [context])

  return (
    <div className='w-full flex flex-col'>
      <Loader isLoading={isLoading || isFetching} />
      {can('add_user') && create ? (
        <EditCreateUser
          state={'create'}
          open={create}
          setOpen={setCreate}
          record={null}
        />
      ) : null}
      {can('change_user') && edit ? (
        <EditCreateUser
          state={'edit'}
          open={edit}
          setOpen={setEdit}
          record={holder}
        />
      ) : null}

      <div className='flex'>
        <SearchAndFilterBar
          columns={columns}
          search={search}
          setSearch={setSearch}
          filters={filters}
          setFilters={setFilters}
          setPagination={setPagination}
        />

        <div className='ml-auto flex gap-4'>
          <DownloadAllDataButton
            lazyQueryHook={useLazyGetUsersQuery}
            fileName='users'
          />
          {can('add_user') && (
            <button
              className='btn btn-outline-theme mb-4'
              onClick={() => setCreate(true)}
            >
              Create New User
            </button>
          )}
        </div>
      </div>

      <div className='row'>
        <ReusableTable
          columns={columns}
          data={data?.data?.results}
          pagination={{
            current: pagination.current,
            pageSize: pagination.pageSize,
            total: data?.data?.count,
            showSizeChanger: true
          }}
          onChange={handleTableChange}
        />
      </div>
    </div>
  )
});

export default Users;
